import { Component, DestroyRef, inject, Optional, signal } from '@angular/core';
import { MatBottomSheetRef } from '@angular/material/bottom-sheet';
import { EntryService } from '../../entry.service';
import { GoogleAnalyticsService } from 'src/app/google-analytics.service';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';
import { EntrySelectors } from 'src/app/state/entry.selectors';
import { Store } from '@ngrx/store';
import { EntryData, PlddtData } from '../../structure-data.models';
import { combineLatest, filter, map, tap } from 'rxjs';
import { PlatformService } from 'src/app/platform.service';

@Component({
  selector: 'app-annotations',
  templateUrl: './annotations.component.html',
  styleUrl: './annotations.component.css',
  standalone: false
})
export class AnnotationsComponent {
  public expanded = signal<boolean>(false);
  private entryService = inject(EntryService);
  public accession = toSignal(this.store.select(EntrySelectors.accession));
  public entryData = signal<EntryData>({} as EntryData);
  public tedDomainData = toSignal(
    this.store.select(EntrySelectors.tedDomainData)
  );
  // public csvAmData = toSignal(this.store.select(EntrySelectors.csvAmData));
  public csvAmData = signal<string>('');
  public averageplddtDisplay:string;

  public hydrationReady: boolean = false;
  constructor(
    @Optional()
    private store: Store,
    private platform: PlatformService,
    public bottomSheetRef: MatBottomSheetRef<AnnotationsComponent>,
    public gaService: GoogleAnalyticsService,
  ) {}
  public plddtData: PlddtData;
  public selectedTabName = this.entryService.selectedTabName;
  private selectedComponent = this.entryService.selectedComponent;
  private readonly destroyRef = inject(DestroyRef);

  alphamissenseLegends: any = [
    { style: { backgroundColor: '#2166ac' }, label: 'Likely benign' },
    { style: { backgroundColor: '#A8A9AC' }, label: 'Uncertain' },
    { style: { backgroundColor: '#b2182b' }, label: 'Likely pathogenic' },
  ];

  ngOnInit(): void {
    if (this.platform.isBrowserPlatform()) {
      this.hydrationReady = true;
    }
    combineLatest([
      this.store.select(EntrySelectors.entryData).pipe(filter(Boolean)),
      this.store.select(EntrySelectors.csvAmData).pipe()
    ])
      .pipe(
        map(([entryData, csvAmData]) => {
          this.entryData.set(entryData)
          this.csvAmData.set(csvAmData)

        }),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }
  
  public closeBottomSheet(): void {
    this.bottomSheetRef.dismiss();
    this.entryService.updateSelectedComponent(null);
    this.entryService.updateSelectedTabName('');
  }

  public toggleBottomsheetHeight(): void {
    this.expanded.update((olamide) => !olamide);
    const container = document.querySelector(
      '.custom-bottom-sheet'
    ) as HTMLElement;
    if (container) {
      container.style.height = this.expanded() ? '50%' : '10%';
    }

    //for GA tag
    let tag = "bottomsheet_toggle_up";
    let gtagmsg = "Opening bottomsheet up";
    if(!this.expanded()){
      tag = "bottomsheet_toggle_down";
      gtagmsg = "Collapsing bottomsheet down";
    }
    this.gaService.eventEmitter('bottomsheet_toggle', 'mobile_overlay_interaction', 'tap', tag, gtagmsg);
  }
}